import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { toast } from "../lib/toast";

function KrogerRetailerCallback() {
  const navigate = useNavigate();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const finishKrogerConnect = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const error = params.get("error");

      if (error) {
        toast.error("Kroger connection was cancelled or denied.");
        navigate("/cart", { replace: true });
        return;
      }

      if (!code || !state) {
        toast.error("Kroger did not return a complete authorization response.");
        navigate("/cart", { replace: true });
        return;
      }

      try {
        await axiosInstance.post(
          "/api/integrations/retailers/connect/complete/",
          { provider: "kroger", code, state },
          { _skipGlobalErrorToast: true }
        );
        toast.success("Kroger account connected.");
        navigate("/cart?retailer=connected", { replace: true });
      } catch (err) {
        console.error("Kroger connection failed:", err);
        toast.error("Kroger connection failed. Please try again.");
        navigate("/cart", { replace: true });
      }
    };

    finishKrogerConnect();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#eef4ff] flex items-center justify-center px-6">
      <div className="rounded-3xl border border-white/80 bg-white/90 px-8 py-10 text-center shadow-[0_30px_80px_-30px_rgba(24,119,242,0.35)] backdrop-blur">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-blue-100 border-t-[#1877f2]" />
        <h1 className="type-section-title mt-5">Connecting Kroger</h1>
        <p className="type-muted mt-2">Hang tight while we finish the secure sign-in flow.</p>
      </div>
    </div>
  );
}

export default KrogerRetailerCallback;
